<template>
  <transition name="fade">
    <div v-if="isShown" class="preloader">
      <div class="lds-ripple">
        <div class="lds-pos"></div>
        <div class="lds-pos"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AdminPreloader",
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isShown() {
      return this.show;
    }
  }
}
</script>